
export default {
  name: "SeoPagination",
  props: {
    totalPages: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    activePage() {
      return this.$route.query.page ? +this.$route.query.page : this.currentPage;
    },
  },
  methods: {
    getPageUrl(page) {
      const query = { ...this.$route.query, page: +page === 1 ? undefined : page };
      const route = {
        path: this.$route.path,
        query,
      };
      return this.localePath(route);
    },
  },
};
